module.exports = __webpack_public_path__ + "static/media/banner2.e8dadc14.jpg";